// extracted by mini-css-extract-plugin
module.exports = {"tab_info":"tabinfo2_tab_info__QZaxS"};